// extracted by mini-css-extract-plugin
module.exports = {"container":"TdOptions_container__1hV3L","button":"TdOptions_button__GD0ND"};